export const removeAccents = input => {
	if (!input) return input;
	return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
